module.exports = __webpack_public_path__ + "8bab78ca93b005f295822804b8df244c.svg";